import { DeviceConnectionStatus } from '@eppendorf/vnls-device-service-utils';
import { Badge } from '@eppendorf/vnls-react-components';
import i18next from 'i18next';
import { ReactElement } from 'react';

import { getConnectionStatusText } from '$features/devices/devices.utils';

export interface ConnectionStatusBadgeProps {
  status?: DeviceConnectionStatus;
  bordered?: boolean;
  size?: 'small' | 'medium';
}

export function ConnectionStatusBadge({
  status,
  bordered = false,
  size = 'medium',
}: ConnectionStatusBadgeProps): ReactElement {
  switch (status) {
    case 'pending':
    case 'readyToPair':
      return (
        <Badge bordered={bordered} color="orange" size={size}>
          {getConnectionStatusText(status)}
        </Badge>
      );
    case 'paired':
      return (
        <Badge bordered={bordered} color="green" size={size}>
          {getConnectionStatusText(status)}
        </Badge>
      );
    case 'waitingForMetadata':
      return (
        <Badge bordered={bordered} color="orange" size={size}>
          {getConnectionStatusText(status)}
        </Badge>
      );
    default:
      return (
        <Badge bordered={bordered} size={size}>
          {i18next.t('translation:activityStatus.offline')}
        </Badge>
      );
  }
}
